module.exports = __webpack_public_path__ + "static/media/slide_1.ff2240a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard/slide_1.png
// module id = 1143
// module chunks = 0